export const env = {
    REACT_APP_PROJECT_ID:"12931990-d9e2-4805-ae9d-ae53240c8e78",
    REACT_APP_CLIENT_KEY:"cBeYPGmZHGrP21IpVsdm7QaOlW04yGI4x58SqpTB",
    REACT_APP_APP_ID:"3e449da0-bd57-43bb-8ed5-a105c9836e18",
    REACT_APP_WALLETCONNECT_PROJECT_ID:"df9499f30b7bb076d4d26ca414514ff5"
}